import { Component, Input } from '@angular/core'
import { NgClass } from '@angular/common'

// Logo Glicosus (manual da marca 2): gota verde com rosto sorridente
@Component({
  selector: 'glico-logo',
  imports: [NgClass],
  template: `
    <div class="flex items-center gap-2 select-none" [ngClass]="{ 'animate-drop': animar }">
      <svg
        [attr.width]="tamanho"
        [attr.height]="tamanho"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        [ngClass]="{ 'animate-float': flutuar }"
        aria-hidden="true"
      >
        <path
          d="M50 10C50 10 20 45 20 65C20 81.5685 33.4315 95 50 95C66.5685 95 80 81.5685 80 65C80 45 50 10 50 10Z"
          [attr.fill]="branco ? '#FFFFFF' : '#10B981'"
        />
        <g class="olhos">
          <circle cx="38" cy="60" r="5" [attr.fill]="branco ? '#10B981' : 'white'" />
          <circle cx="62" cy="60" r="5" [attr.fill]="branco ? '#10B981' : 'white'" />
        </g>
        <path
          d="M42 72C42 72 46 76 50 76C54 76 58 72 58 72"
          [attr.stroke]="branco ? '#10B981' : 'white'"
          stroke-width="4"
          stroke-linecap="round"
        />
      </svg>
      @if (comNome) {
        <span class="font-bold tracking-tight" [ngClass]="[branco ? 'text-white' : 'text-glico-texto', classeNome]">Glicosus</span>
      }
    </div>
  `,
  styles: `
    .olhos {
      transform-box: fill-box;
      transform-origin: center;
      animation: piscar 5s ease-in-out infinite;
    }
    @keyframes piscar {
      0%, 92%, 100% { transform: scaleY(1); }
      96% { transform: scaleY(0.1); }
    }
  `,
})
export class GlicoLogoComponent {
  @Input() tamanho = 32
  @Input() comNome = true
  @Input() branco = false
  @Input() animar = false
  @Input() flutuar = false
  @Input() classeNome = 'text-xl'
}
